import { formatDateDayjs } from 'utilities/date';

export interface MessagesMungedByDay {
  [key: string]: Array<Message>;
}

export function mungeMessagesByDay(messages: Message[]) {
  return messages.reduce((acc, message) => {
    const formattedDate = formatDateDayjs(message.createdAt, 'MMM d yyyy');

    if (acc[formattedDate]) {
      acc[formattedDate].push(message);
    } else {
      acc[formattedDate] = [message];
    }

    return acc;
  }, {} as MessagesMungedByDay);
}
